import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

interface SetPathLookupColorDetectedLoopsCommand {
  colorDetectedLoops: boolean;
}

export const setPathLookupColorDetectedLoops: GraphCommandFactory<
  SetPathLookupColorDetectedLoopsCommand
> = (cmdContext) => (command) => {
  cmdContext.updateState((draft) => {
    draft.pathlookup.presetDraft.pathLookup.colorDetectedLoops =
      command.colorDetectedLoops;
  });
};
